import {API_KEY_STORE_NAME} from '../reducers/reducers'

export function getApiKeysForUsagePlan(state, usagePlanId) {
    const stored = state[API_KEY_STORE_NAME] || { }
    return usagePlanId && stored.items ? stored.items[usagePlanId] : undefined
}
